<template>
  <ul class="card-list">
    <li class="card-item">
      <card2
        title="温湿度数据未上传"
        imgName="leaf"
        :titleList="wsdTitleList"
        :briefList="wsdBriefList"
        @loadMore="loadBriefList('wsd')"
        :isLastPage="wsdIsLastPage"
      />
    </li>
    <li class="card-item">
      <card2
        title="进销存数据未上传"
        imgName="car"
        :titleList="jxcTitleList"
        :briefList="jxcBriefList"
        @loadMore="loadBriefList('jxc')"
        :isLastPage="jxcIsLastPage"
      />
    </li>
    <li class="card-item">
      <card2
        title="原辅料质检报告未上传"
        imgName="car"
        :titleList="yflTitleList"
        :briefList="yflBriefList"
        @loadMore="loadBriefList('yfl')"
        :isLastPage="yflIsLastPage"
      />
    </li>
    <li class="card-item">
      <card2
        title="成品质检报告未上传"
        imgName="car"
        :titleList="cpTitleList"
        :briefList="cpBriefList"
        @loadMore="loadBriefList('cp')"
        :isLastPage="cpIsLastPage"
      />
    </li>
  </ul>
</template>

<script>
import Card2 from 'components/card/card2';
const cardTypeMap = {
  wsd: '1',
  jxc: '2',
  yfl: '3',
  cp: '4'
};

export default {
  data() {
    return {
      wsdCurrentPage: 0,
      wsdIsLastPage: false,
      wsdTitleList: [],
      wsdBriefList: [],
      jxcCurrentPage: 0,
      jxcIsLastPage: false,
      jxcTitleList: [],
      jxcBriefList: [],
      yflCurrentPage: 0,
      yflIsLastPage: false,
      yflTitleList: [],
      yflBriefList: [],
      cpCurrentPage: 0,
      cpIsLastPage: false,
      cpTitleList: [],
      cpBriefList: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loadEntNum();
    },
    loadEntNum() {
      this.$request({
        url: 'rest/dataControl/getDataEntNum'
      }).then(res => {
        this.wsdTitleList = res.environmentList.map(item => ({
          text: `相关${this.$common.entTypeMap[item.ent_type]}数量`,
          num: item.wsd_num
        }));
        this.jxcTitleList = res.purchaseList.map(item => ({
          text: `相关${this.$common.entTypeMap[item.ent_type]}数量`,
          num: item.jxc_num
        }));
        this.yflTitleList = [
          { text: `相关生产企业数量`, num: res.materialCount }
        ];
        this.cpTitleList = [
          { text: `相关生产企业数量`, num: res.productCount }
        ];
      });
    },
    loadBriefList(type) {
      this[`${type}CurrentPage`] += 1;
      this.$request({
        url: 'rest/dataControl/getDataListNum',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: this[`${type}CurrentPage`],
              pageSize: 10
            },
            params: {
              dataType: cardTypeMap[type]
            }
          })
        }
      }).then(res => {
        this[`${type}IsLastPage`] = res.isLastPage;
        const result = res.list.map(item => ({
          title: item.dateDesc,
          briefItemList: item.nameList
        }));
        this[`${type}BriefList`] = this[`${type}BriefList`].concat(result);
      });
    }
  },
  components: {
    Card2
  }
};
</script>

<style lang="stylus" scoped>
.card-list
  overflow hidden
  display flex
  justify-content center
  .card-item
    float left
    margin-right 45px
    &:last-child
      margin-right 0
</style>
